<template>
  <div class="row">
    <div class="col-12" id="divToPrint" ref="content" v-if="periodos">
      <div class="form-row form_padrao">
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="nomeOperador"
            id="nomeOperador"
            required
            @keyup="filterValue($event)"
          />
          <label for="nomeOperador">Pesquisar períodos - ex: 2020-04</label>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="list-group" v-if="newObj.length > 0">
            <router-link
              v-for="(boleto, index) in newObj"
              :key="index"
              :to="{
                name: 'extrato-utilizacao-unimed',
                params: { periodo: boleto.dtref },
              }"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center mb-2 shadow-sm border-0 rounded"
            >
              <div class="d-flex align-items-center">
                <div class="icon-periodo mr-3">
                  <i class="material-icons">analytics</i>
                </div>

                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">
                    Coparticipação
                  </h6>

                  <small class="text-muted">
                    Competência: {{ formatarPeriodo(boleto.dtref) }}
                  </small>
                </div>
              </div>

              <div>
                <span class="btn btn-sm btn-outline-primary d-flex align-items-center">
                  <i class="material-icons mr-1" style="font-size: 16px;">visibility</i>
                  Ver detalhes
                </span>
              </div>
            </router-link>
          </div>

          <div class="col-12" v-if="newObj.length == 0">
            <div class="card border-0 py-5 d-flex justify-content-center align-items-center bg-light">
              <h5 class="text-muted">
                <i class="material-icons mr-2 align-middle">search_off</i>
                Nada Encontrado.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" v-else>
      <loading />
    </div>
  </div>
</template>

<script>
import { filterByValue } from "../../helpers";
import "vue-select/dist/vue-select.css";

export default {
  name: "relatorio-plano",

  data() {
    return {
      relatorio: "RelatorioExtratoUtilizacaoCoParUnimed",
      periodoRelatorio: "AnoMesRelatorioExtratoUtilizacaoCoParUnimed",
      newObj: "",
      periodos: "",
      relatorioData: "",
      selected: "",
      produto: {
        nome: "Relatório de Coparticipação ",
        id: "relatorio plano",
      },
    };
  },

  watch: {
    selected(value) {
      this.getRelatorio(value.dtref);
    },
  },

  components: {},

  methods: {
    formatarPeriodo(periodo) {
      if (!periodo) return "";

      const valor = String(periodo).trim();

      if (valor.includes("-")) {
        const partes = valor.split("-");

        if (partes.length === 2) {
          return `${partes[1]}/${partes[0]}`;
        }
      }

      return valor;
    },

    filterValue(value) {
      this.newObj = filterByValue(this.periodos, value.target.value);
    },

    getRelatorio(period) {
      this.$http
        .get("/api/CdlBh/" + this.relatorio + "?AnoMes=" + period)
        .then((response) => {
          this.relatorioData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPeriodos() {
      this.$http
        .get("/api/CdlBh/" + this.periodoRelatorio)
        .then((response) => {
          this.periodos = response.data.reverse();
          this.newObj = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPeriodos();
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>

<style lang="scss" scoped>
$azul-institucional: #05428e;
$azul-claro: #eef5ff;

.list-group-item {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  min-height: 82px;
  border-left: 4px solid transparent !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
    background-color: #f8f9fa;
    border-left: 4px solid $azul-institucional !important;
  }

  h6 {
    color: #333;
  }

  small {
    line-height: 1.5rem;
  }
}

.icon-periodo {
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: 50%;
  background: $azul-claro;
  color: $azul-institucional;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 25px;
  }
}

.btn-outline-primary {
  color: $azul-institucional;
  border-color: $azul-institucional;
  font-weight: 700;

  &:hover {
    background-color: $azul-institucional;
    color: #ffffff;

    i {
      color: #ffffff;
    }
  }

  i {
    color: $azul-institucional;
  }
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .list-group-item {
    align-items: flex-start !important;
    flex-direction: column;
    gap: 14px;
  }

  .btn-outline-primary {
    width: 100%;
    justify-content: center;
  }
}
</style>